"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TagManager = _interopRequireDefault(require("../TagManager"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var GoogleProvider = function GoogleProvider(_a) {
  var children = _a.children,
      settings = _a.settings,
      gtm = _a.gtm;
  (0, _react.useEffect)(function () {
    if (settings.FEATURE.GOOGLE_TAG_MANAGER && gtm) {
      _TagManager["default"].initialize(gtm.KEY);
    }
  }, [gtm, settings.FEATURE.GOOGLE_TAG_MANAGER]);
  return _react["default"].createElement(_react["default"].Fragment, null, children);
};

var _default = GoogleProvider;
exports["default"] = _default;